import { useTheme, PageWrap, ThemeToggle, Nav, SERIF, SANS, PLAY, btnStyle, LineDivider } from "./theme";

export default function OrderConfirmation() {
  var { mode, t, toggle } = useTheme();
  var params = new URLSearchParams(window.location.search);
  var personName = params.get("name") || "Someone Special";
  var crystalStyle = params.get("style") || "voices";
  var slug = params.get("c") || "";

  var steps = [
    { num: "I", title: "Order Confirmed", desc: "Payment received. Your poster is in the queue.", done: true },
    { num: "II", title: "Design Printed", desc: "Your constellation is printed on enhanced matte paper at full resolution.", done: false },
    { num: "III", title: "Framed", desc: "Mounted in a slim black frame with a clean, gallery-ready finish.", done: false },
    { num: "IV", title: "Shipped", desc: "Tracking number sent to your email. Arrives in 5\u20137 business days.", done: false },
  ];

  return (
    <PageWrap t={t}>
      <style>{`@keyframes ytFadeIn { from { opacity:0; transform:translateY(20px); } to { opacity:1; transform:translateY(0); } }`}</style>
      <ThemeToggle t={t} toggle={toggle} mode={mode} />
      <Nav t={t} />

      <div style={{ maxWidth: 540, margin: "0 auto", padding: "80px 24px 120px", textAlign: "center" }}>
        <div style={{ animation: "ytFadeIn 0.8s ease-out" }}>
          <p style={{ fontSize: 56, color: t.accent, margin: "0 0 32px", lineHeight: 1 }}>{"\u2726"}</p>
          <p style={{ fontFamily: SANS, fontSize: 9, fontWeight: 300, letterSpacing: 8, color: t.accentSoft, textTransform: "uppercase", marginBottom: 28 }}>Order Confirmed</p>
          <h1 style={{ fontFamily: PLAY, fontWeight: 400, fontSize: "clamp(26px, 5vw, 38px)", fontStyle: "italic", color: t.text, margin: "0 0 16px", lineHeight: 1.3, letterSpacing: 1 }}>
            A framed poster for {personName}<br />is being printed.
          </h1>
          <p style={{ fontFamily: SERIF, fontStyle: "italic", fontSize: 16, fontWeight: 300, color: t.textSoft, lineHeight: 1.9, maxWidth: 420, margin: "0 auto 20px" }}>
            {crystalStyle.charAt(0).toUpperCase() + crystalStyle.slice(1)} style {"\u00B7"} Enhanced Matte {"\u00B7"} Black Frame
          </p>
          <p style={{ fontFamily: SANS, fontSize: 12, fontWeight: 300, color: t.textMuted, letterSpacing: 1 }}>Confirmation sent to your email.</p>
        </div>

        <div style={{ padding: "48px 0" }}><LineDivider t={t} /></div>

        <div style={{ textAlign: "left", maxWidth: 400, margin: "0 auto", animation: "ytFadeIn 1s ease-out 0.3s both" }}>
          <p style={{ fontFamily: SANS, fontSize: 9, fontWeight: 300, letterSpacing: 8, color: t.accentSoft, textTransform: "uppercase", marginBottom: 40, textAlign: "center" }}>Timeline</p>
          {steps.map(function(step, i) {
            var isLast = i === steps.length - 1;
            return (
              <div key={i} style={{ display: "flex", gap: 24, marginBottom: isLast ? 0 : 36, position: "relative" }}>
                {!isLast && <div style={{ position: "absolute", left: 14, top: 28, bottom: -36, width: 1, background: step.done ? t.accentMuted : t.border }} />}
                <div style={{ width: 28, height: 28, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid " + (step.done ? t.accent : t.border), background: step.done ? t.accentMuted : "transparent", position: "relative", zIndex: 1 }}>
                  <span style={{ fontFamily: SERIF, fontSize: 11, fontStyle: "italic", color: step.done ? t.accent : t.textMuted }}>{step.num}</span>
                </div>
                <div style={{ paddingTop: 2 }}>
                  <p style={{ fontFamily: PLAY, fontSize: 16, fontWeight: 400, color: step.done ? t.text : t.textMuted, margin: "0 0 4px", letterSpacing: 0.5 }}>{step.title}</p>
                  <p style={{ fontFamily: SANS, fontSize: 12, fontWeight: 300, color: step.done ? t.textSoft : t.textMuted, margin: 0, lineHeight: 1.6 }}>{step.desc}</p>
                </div>
              </div>
            );
          })}
        </div>

        {slug && (
          <div style={{ padding: "56px 0 0", animation: "ytFadeIn 1s ease-out 0.5s both" }}>
            <a href={"/constellation?c=" + slug} style={{ ...btnStyle(t, "secondary"), padding: "16px 40px" }}>View the constellation</a>
          </div>
        )}
      </div>
    </PageWrap>
  );
}
